import { EDefaultPriceFreq, EListingSellOrRent, ListingProperties } from "../types/listing.type";

export const priceFormat = (price: string | number | undefined, currency?: string) => {
	if (price === undefined || price === null) {
		return "";
	}
	var formatter = new Intl.NumberFormat("en-US", {
		// style: "currency",
		// currency: currency ?? "IDR",
		maximumFractionDigits: 0,
		minimumFractionDigits: 0,
	});
	return formatter.format(Number(price));
};
export const priceShorten = (num: number) => {
	return Math.abs(Number(num)) >= 1.0e9
		? Math.round(Math.abs(Number(num)) / 1.0e9) + " M"
		: Math.abs(Number(num)) >= 1.0e6
		? Math.round(Math.abs(Number(num)) / 1.0e6) + " Jt"
		: Math.abs(Number(num)) >= 1.0e3
		? Math.round(Math.abs(Number(num)) / 1.0e3) + " Rb"
		: Math.abs(Number(num));
};
export const toPercentage = (num: number, total: number) => {
	let percentage = (num / total) * 100;
	return Math.round((percentage + Number.EPSILON) * 100) / 100;
};
export const roundTwoDecimal = (num: number) => {
	return Math.round((num + Number.EPSILON) * 100) / 100;
};
export const renderFloatPercentage = (float?: number | string) => {
	if (float === undefined) return undefined;

	return Number(float) * 100 + "%";
};

export const getListingPrice = (listing?: ListingProperties) => {
	if (listing?.sellOrRent === EListingSellOrRent.RENT) {
		if (listing.defaultPriceFreq) {
			let freq = "";

			switch (listing.defaultPriceFreq) {
				case EDefaultPriceFreq.daily:
					freq = "/hari";
					break;
				case EDefaultPriceFreq.monthly:
					freq = "/bln";
					break;
				case EDefaultPriceFreq.yearly:
					freq = "/thn";
					break;
				default:
					freq = "";
					break;
			}

			if (listing?.additionalPriceFreq && listing?.additionalPriceFreq[listing?.defaultPriceFreq]) {
				return "Rp " + priceShorten(listing?.additionalPriceFreq[listing?.defaultPriceFreq]!) + freq;
			}
		} else {
			if (listing.additionalPriceFreq?.yearly) {
				return "Rp " + priceShorten(listing.additionalPriceFreq?.yearly) + "/thn";
			}

			if (listing.additionalPriceFreq?.monthly) {
				return "Rp " + priceShorten(listing.additionalPriceFreq?.monthly) + "/bln";
			}
			if (listing.additionalPriceFreq?.daily) {
				return "Rp " + priceShorten(listing.additionalPriceFreq?.daily) + "/hari";
			}

			if (
				!listing.additionalPriceFreq?.yearly &&
				!listing.additionalPriceFreq?.monthly &&
				!listing.additionalPriceFreq?.daily
			) {
				return "Rp " + priceShorten(listing.price ?? 0) + "/???";
			}
		}
	}
	return "Rp " + (listing?.price ? priceShorten(listing?.price) : "-");
};

export const getListingPriceNominal = (listing?: ListingProperties, isFull?: boolean, hideRp?: boolean) => {
	let rp = hideRp ? "" : "Rp ";
	if (listing?.sellOrRent === EListingSellOrRent.RENT) {
		if (listing.defaultPriceFreq) {
			let freq = "";

			switch (listing.defaultPriceFreq) {
				case EDefaultPriceFreq.daily:
					freq = "/hari";
					break;
				case EDefaultPriceFreq.monthly:
					freq = "/bln";
					break;
				case EDefaultPriceFreq.yearly:
					freq = "/thn";
					break;
				default:
					freq = "";
					break;
			}
			if (listing?.additionalPriceFreq && listing?.additionalPriceFreq[listing?.defaultPriceFreq]) {
				return isFull
					? rp + priceFormat(Number(listing?.additionalPriceFreq[listing?.defaultPriceFreq]!)) + freq
					: priceFormat(Number(listing?.additionalPriceFreq[listing?.defaultPriceFreq]!));
			}
		} else {
			if (listing.additionalPriceFreq?.yearly) {
				return isFull
					? rp + priceFormat(listing.additionalPriceFreq?.yearly) + "/thn"
					: priceFormat(listing.additionalPriceFreq?.yearly);
			}

			if (listing.additionalPriceFreq?.monthly) {
				return isFull
					? rp + priceFormat(listing.additionalPriceFreq?.monthly) + "/bln"
					: priceFormat(listing.additionalPriceFreq?.monthly);
			}
			if (listing.additionalPriceFreq?.daily) {
				return isFull
					? rp + priceFormat(listing.additionalPriceFreq?.daily) + "/hari"
					: priceFormat(listing.additionalPriceFreq?.daily);
			}

			if (
				!listing.additionalPriceFreq?.yearly &&
				!listing.additionalPriceFreq?.monthly &&
				!listing.additionalPriceFreq?.daily
			) {
				return isFull ? rp + priceFormat(listing.price) + "/hari" : priceFormat(listing.price);
			}
		}
	}
	return listing?.price ? priceFormat(listing?.price) : 0;
};
